/** Joins class names, skipping falsy values. Tiny on purpose: no dependency. */
export function cx(...parts) {
    const out = parts.filter(Boolean).join(' ');
    return out === '' ? undefined : out;
}
//# sourceMappingURL=cx.js.map